export const manifest = {
  screens: {
    scr_m3ewpi: { name: "Snakker for LEO Pharma", route: "/", state: {"slideIndex":0}, position: {"x":160,"y":220} },
    scr_why001: { name: "Snakker — why we exist", route: "/", state: {"slideIndex":1}, position: {"x":1560,"y":220} },
    scr_roc002: { name: "What we learned from Roche", route: "/", state: {"slideIndex":2}, position: {"x":2960,"y":220} },
    scr_prf007: { name: "Already delivering campaign work with LEO Pharma", route: "/", state: {"slideIndex":3}, position: {"x":9960,"y":220} },
    scr_lnd011: { name: "Brands, campaigns and markets already in play", route: "/", state: {"slideIndex":4}, position: {"x":14160,"y":220} },
    scr_drx010: { name: "Leo Pharma UK — DERMX webinar series", route: "/", state: {"slideIndex":5}, position: {"x":15560,"y":220} },
    scr_ana008: { name: "Inside a LEO campaign flow", route: "/", state: {"slideIndex":6}, position: {"x":11360,"y":220} },
    scr_del003: { name: "Snak campaign delivery model and cost structure", route: "/", state: {"slideIndex":7}, position: {"x":4360,"y":220} },
    scr_val004: { name: "Value proposition for LEO Pharma", route: "/", state: {"slideIndex":8}, position: {"x":5760,"y":220} },
    scr_ctl005: { name: "Control Tower — the enterprise platform", route: "/", state: {"slideIndex":9}, position: {"x":7160,"y":220} },
    scr_ctv009: { name: "What Control Tower brings to LEO", route: "/", state: {"slideIndex":10}, position: {"x":12760,"y":220} },
    scr_ope006: { name: "The LEO operating model", route: "/", state: {"slideIndex":11}, position: {"x":8560,"y":220} },
    scr_stb012: { name: "The full deck, page by page", route: "/", state: {"slideIndex":12}, position: {"x":160,"y":2200} },
  },
  sections: {
    sec_m90zky: { name: "Snakker Pitch Deck", x: 0, y: 0, width: 16920, height: 1180 },
    sec_jydty0: { name: "Deck Navigator", x: 0, y: 1980, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_m90zky", children: [
      { kind: "screen", id: "scr_m3ewpi" },
      { kind: "screen", id: "scr_why001" },
      { kind: "screen", id: "scr_roc002" },
      { kind: "screen", id: "scr_del003" },
      { kind: "screen", id: "scr_val004" },
      { kind: "screen", id: "scr_ctl005" },
      { kind: "screen", id: "scr_ope006" },
      { kind: "screen", id: "scr_prf007" },
      { kind: "screen", id: "scr_ana008" },
      { kind: "screen", id: "scr_ctv009" },
      { kind: "screen", id: "scr_drx010" },
      { kind: "screen", id: "scr_lnd011" },
    ] },
    { kind: "section", id: "sec_jydty0", children: [
      { kind: "screen", id: "scr_stb012" },
    ] },
  ],
}
